<template>
  <div class="flex flex-col gap-1">
    <div class="flex items-center gap-2">
      <app-badge size="sm">{{ commissionRate.rate?.rate_code || 'N/A' }}</app-badge>
      <span class="app-leader" />
      <span class="text-sm font-medium">{{ formattedCommission }}</span>
    </div>
    <p class="text-xs text-gray-600">({{ commissionAmount }} commission applied to {{ pricingComponentLabel }})</p>
  </div>
</template>

<script setup>
import { computed } from 'vue';
import { formatNumber } from '@/utils/number';
import { CommissionType, PricingComponentCopy } from '@/constants/reservations';

const props = defineProps({
  commissionRate: {
    type: Object,
    required: true,
    default: () => ({}),
  },
  currencyCode: {
    type: String,
    required: true,
    default: 'USD',
  },
});

const formattedCommission = computed(() =>
  formatNumber({
    value: props.commissionRate.commission,
    options: { style: 'currency', currency: props.currencyCode },
  })
);

const pricingComponentLabel = computed(() =>
  (PricingComponentCopy[props.commissionRate.pricing_component] || props.commissionRate.pricing_component).toLowerCase()
);

const commissionAmount = computed(() => {
  const { commission_type, commission_amount } = props.commissionRate.rate || {};
  if (commission_type === CommissionType.PERCENTAGE) {
    return `${commission_amount}%`;
  }
  return formatNumber({
    value: commission_amount,
    options: { style: 'currency', currency: props.currencyCode },
  });
});
</script>
